import {Component, EventEmitter, Input, Output} from '@angular/core';

import {ErrorModel} from '../../model/error.model';
import {
  MatCard,
  MatCardAvatar,
  MatCardContent,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle
} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import { environment } from '../../../environment';

/**
 * @class
 * @component
 * @description This class maintains the page component of our application, which wraps pages to handle errors.
 * @export
 * @name PageComponent
 */
@Component({
  imports: [
    MatCard,
    MatCardAvatar,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
    MatIcon
  ],
  selector: 'app-page',
  standalone: true,
  styleUrl: './page.component.scss',
  templateUrl: './page.component.html'
})
export class PageComponent {

  /**
   * @description This property contains any errors that occurred during the execution of the page component.
   * @memberof PageComponent
   * @name PageComponent#error
   * @property
   * @protected
   * @type {ErrorModel?}
   */
  @Input()
  public error?: ErrorModel;

  /**
   * @description This property contains the error event for the component.
   * @memberof PageComponent
   * @name PageComponent#errorChange
   * @property
   * @public
   * @type {EventEmitter<ErrorModel>}
   */
  @Output()
  public errorChange: EventEmitter<ErrorModel> = new EventEmitter<ErrorModel>();

  /**
   * @description This method determines if the application is in production mode.
   * @memberof PageComponent
   * @method
   * @name PageComponent#isProduction
   * @public
   * @returns {boolean} True if the application is in production mode, false otherwise.
   */
  public isProduction(): boolean {
    return environment.production;
  }
}
